import { render, staticRenderFns } from "./InpatientWarrant.vue?vue&type=template&id=5d4baf81&scoped=true"
import script from "./InpatientWarrant.vue?vue&type=script&lang=js"
export * from "./InpatientWarrant.vue?vue&type=script&lang=js"
import style0 from "./InpatientWarrant.vue?vue&type=style&index=0&id=5d4baf81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4baf81",
  null
  
)

export default component.exports